import React, { useEffect, useRef, useState } from "react";
import ProjectCount from "./ProjectCount";
import Expenditure from "./Expenditure";
import Programmes from "./Programmes";
import Pathways from "./Pathways";
import ProjectTargetsCard from "./ProjectTargetsCard";
import HarvestingCard from "./HarvestingCard";
import BreadCrumb from "../../../layout/BreadCrumb";
import LeafletMap from "./LeafletMap";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import CardLoading from "../../../components/CardLoading";
import { fetchData } from "../../../features/fetch/fetchSlice";
import { Form, Select } from "antd";

function ProjectOverviewList() {
  const { user } = useSelector((state) => state.auth);
  const [form] = Form.useForm();
  const formRef = useRef(null);
  const [active, setActive] = useState("Overview");
  const [selectId, setSelectId] = useState(null);

  const urlPathway = "api/v2/irrigationPathway/get";
  const handleChange = (value) => {
    setActive(value);
  };
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const url = "api/v2/dashboard/getProjectDashboardData";
  const { loading, data, count, dataPathway } = useSelector((state) => ({
    loading: state.fetch.loading,
    data: state.fetch.data[url] || [],
    count: state.fetch.count[url] || 0,
    dataPathway: state.fetch.data[urlPathway] || [],
  }));

  async function fetchDashData() {
    await dispatch(
      fetchData({
        url: url,
        pathwayId: selectId,
        limit: null,
        start: 0,
      })
    );
  }

  useEffect(() => {
    dispatch(
      fetchData({
        url: urlPathway,
        limit: null,
        start: 0,
      })
    );
  }, []);

  useEffect(() => {
    fetchDashData();
  }, [selectId]);
  if (loading) return <CardLoading />;
  return (
    <>
      <div className="flex lg:flex-row flex-col lg:items-center lg:justify-between gap-[.75rem]">
        <Form
          layout="vertical"
          ref={formRef}
          name="control-ref"
          className="lg:w-[20%] w-full"
          form={form}
        >
          <div className="w-full banner-select flex items-center gap-x-[.5rem] text-[#6B7280] text-[.875rem] font-[400] font-interSans">
            <span className="">Pathway</span>
            <Select
              className="banner-selector "
              allowClear
              style={{
                width: "100%",
              }}
              options={
                dataPathway?.length > 0 &&
                dataPathway?.map((item) => ({
                  value: item?.irrigationPathwayId,
                  label: item?.irrigationPathwayName,
                }))
              }
              value={selectId}
              onChange={(value) => setSelectId(value)}
              placeholder="Select"
              showSearch
              optionFilterProp="children"
              filterOption={(input, option) =>
                (option?.label?.toLocaleLowerCase() ?? "").includes(
                  input?.toLocaleLowerCase()
                )
              }
            />
          </div>
        </Form>
        <div className="border border-[#D6E1F5] rounded-[1.5rem] p-[.5rem] bg-white flex items-center gap-x-[.5rem] w-auto">
          <button
            onClick={() => handleChange("Overview")}
            className={`py-[0.375rem] px-[.75rem] rounded-[1.5625rem] text-[.75rem] font-[400] font-interSans  ${
              active === "Overview"
                ? "text-white bg-darkBlue"
                : "text-[#424242] bg-white"
            }`}
          >
            Overview
          </button>
          <button
            onClick={() => handleChange("Map")}
            className={`py-[0.375rem] px-[.75rem] rounded-[1.5625rem] text-[.75rem] font-[400] font-interSans  ${
              active === "Map"
                ? "text-white bg-darkBlue"
                : "text-[#424242] bg-white"
            }`}
          >
            Map Analysis
          </button>
        </div>
      </div>
      {active === "Overview" ? (
        <>
          {" "}
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-[1.25rem] w-full mt-[.75rem]">
            <ProjectCount />
            <Expenditure />
            <Programmes />
          </div>
          <div className="grid sm:grid-cols-1 lg:grid-cols-2 gap-[1.25rem] w-full mt-[1.25rem]">
            <ProjectTargetsCard metric="area" />
            <ProjectTargetsCard metric="beneficiaries" />
          </div>
          <div className="grid sm:grid-cols-1 lg:grid-cols-2 gap-[1.25rem] w-full mt-[1.25rem]">
            <Pathways />
            <HarvestingCard />
          </div>
        </>
      ) : (
        <div className="mt-[.75rem]">
          {" "}
          <LeafletMap />
        </div>
      )}
    </>
  );
}

export default ProjectOverviewList;
